import _ from "lodash";
import { RESERVATION_CONFIG } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        reservationConfig: _.cloneDeep(constants.RESERVATION_CONFIG_INPUT)
    }
}

const reservationConfigReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESERVATION_CONFIG.SET_RESERVATION_CONFIG_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case RESERVATION_CONFIG.SET_RESERVATION_CONFIG:
        case RESERVATION_CONFIG.SET_RESERVATION_CONFIG_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    reservationConfig: action.reservationConfig
                }
            })
        default:
            return state
    }
}

export default reservationConfigReducer